import lazySizes from 'lazysizes'; // eslint-disable-line no-unused-vars
import copy from 'copy-text-to-clipboard';
import ButtonForm from './components/buttonForm';
import Calendar from './components/calendar';
import ContentModal from './components/contentModal';
import Log from './components/log';
import Navigation from './components/navigation';
import Showtimes from './components/showtimes';
import Slider from './components/slider';
import Tooltip from './components/tooltip';
import VideoModal from './components/videoModal';

const buttonForm = new ButtonForm(); // eslint-disable-line no-unused-vars
const calendar = new Calendar(); // eslint-disable-line no-unused-vars
const contentModal = new ContentModal(); // eslint-disable-line no-unused-vars
const navigation = new Navigation(); // eslint-disable-line no-unused-vars
const showtimes = new Showtimes(); // eslint-disable-line no-unused-vars
const slider = new Slider(); // eslint-disable-line no-unused-vars
const tooltip = new Tooltip(); // eslint-disable-line no-unused-vars
const videoModal = new VideoModal(); // eslint-disable-line no-unused-vars
//
//
// Misc. Global and Generic Functions

$('body').on('click', '.newsletter-form-submit', () => {
  Log.track('Newsletter', 'sign up', null, true);
});
$('.js-external_link').on('click', (event) => {
  Log.track('External Link', 'click', event.target.href, true);
});

$('.js-share-popup').click(function sharePopup(event) {
  event.preventDefault();
  const shareURL = $(this).attr('href');
  const w = 600;
  const h = 300;
  const left = (window.screen.width / 2) - (w / 2);
  const top = (window.screen.height / 2) - (h / 2);
  const shareWindow = window.open(shareURL, 'Film Streams', `location=0,status=1,scrollbars=1,width=${w},height=${h},top=${top},left=${left},toolbar=no`);
  return shareWindow;
});

$('.js-scrollto').on('click', (event) => {
  event.preventDefault();
  const anchor = $(event.currentTarget).attr('href');
  $('html, body').animate({
    scrollTop: $(anchor).offset().top,
  }, 300);
  window.setTimeout(() => {
    const highlightClass = '.js-highlight';
    $(highlightClass).addClass('highlight');
    window.setTimeout(() => {
      $(highlightClass).removeClass('highlight');
    }, 800); // Match animation time
  }, 500);
});

// Mobile category navigation toggle
$('.js-category_nav-toggle').on('click', (event) => {
  event.preventDefault();
  $('.js-category_nav').toggleClass('is-open');
});

// Fallback to ensure that typekit loading class gets removed
window.setTimeout(() => {
  $('html.wf-loading').removeClass('wf-loading');
}, 3000);

// Add `rel="noopener"` or `rel="noreferrer"` to any external links
// to improve performance and prevent security vulnerabilities.
$("a[target='_blank']:not([rel='noopener noreferrer'])").attr('rel', 'noopener noreferrer');

// Click to Copy
$('.js-copy').on('click', (event) => {
  event.preventDefault();
  const element = event.currentTarget;
  copy(element.href);
  element.classList.add('copied');
  setTimeout(() => {
      element.classList.remove('copied');
  }, 2000);
});
